<div class="col-12">
  @if (utility.diagnose$ | async; as response ) {
    <div>Response: {{response}}</div>
  }
</div>
